<template>
  <div class="timeline-item-header">
    <div class="timeline-item-start">
      <span v-if="isPrediction">
        <span class="has-text-weight-medium">{{ $t('user.timeline.eta') }}:</span>
        {{ start }} - {{ end }}
      </span>
      <span v-else>{{ start }}</span>
    </div>
    <div class="timeline-item-timezone">{{ timezone }}</div>
    <span class="timeline-item-date" v-if="isFirst">{{ date }}</span>
  </div>
</template>

<script>
export default {
  name: "TimelineItemHeader",
  props: {
    start: {
      type: String,
      required: true
    },
    end: {
      type: String,
      required: true
    },
    timezone: {
      type: String,
      required: true
    },
    date: String,
    isFirst: {
      type: Boolean,
      required: true
    },
    isPrediction: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.timeline-item-header {
  display: flex;
}

.timeline-item-start,
.timeline-item-end,
.timeline-item-date {
  font-size: $size-small;
  line-height: 1.33;
  color: rgba($black, 0.72);
}

.timeline-item-date {
  border-left: 1px solid rgba($black, 0.24);
  padding-left: 0.625rem;
  margin-left: 0.625rem;
}

.timeline-item-timezone {
  font-size: 0.625rem;
  line-height: 1.6;
  letter-spacing: 0.2px;
  color: rgba($black, 0.48);
  margin-left: 0.375rem;
}
</style>
